<template>
  <v-container class="pt-10 px-8">
    <v-row class="mb-6" align="center" justify="space-between">
      <v-col cols="12" md="6">
        <div style="font-family: 'montserrat-bold'; font-size: 28px; color: black;">
          Lista de facturas
        </div>
        <div style="font-family: 'montserrat-regular'; font-size: 14px;">
          Aquí puedes revisar el estatus completo de todas las facturas disponibles.
        </div>
      </v-col>
    </v-row>

    <v-row class="mb-6" align="center" justify="space-between">
      <v-spacer />
      <v-col cols="12" md="6" class="d-flex justify-end">
        <v-btn
          color="black"
          class="white--text"
          rounded
          elevation="4"
          style="text-transform: none; font-family: 'montserrat-semibold';"
          @click="dialogCreateInvoice = true, factura = { numero: '', cedenteId: '', deudor: '', monto: 0, fechaEmision: '', fechaVencimiento: '', archivos: [] }"
        >
          Agregar factura
        </v-btn>
      </v-col>
    </v-row>
    <v-expansion-panels multiple accordion>
      <v-expansion-panel class="mb-4" style="border-radius: 15px;">
        <v-expansion-panel-header class="py-8" style="font-family: 'montserrat-semibold'; font-size: 16px;">
          Facturas por aprobar ({{ invoicesPorValidar?.length || 0 }})
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-data-table
            :items="invoicesPorValidar"
            hide-default-header
            style="background-color: white !important"
            >
            <template v-slot:header>
              <thead style="background-color: #f9fafd;">
                <tr>
                  <th class="header__title left">Cedente</th>
                  <th class="header__title center">Deudor</th>
                  <th class="header__title center">Id</th>
                  <th class="header__title center">Reference</th>
                  <th class="header__title center">Monto</th>
                  <th class="header__title center">Fecha de emisión</th>
                  <th class="header__title center">Fecha de vencimiento</th>
                  <th class="header__title center">Status</th>
                  <th class="header__title right">Acciones</th>
                </tr>
              </thead>
            </template>
            <template v-slot:body="{ items }">
              <tbody style="background: #f9fafd;">
                <tr v-for="item in items" :key="item.id">
                  <td class="table__item center">{{ item.cedente_name }}</td>
                  <td class="table__item center">{{ item.deudor_name }}</td>
                  <td class="table__item center">{{ item.external_invoice_id }}</td>
                  <td class="table__item center">{{ item.reference }}</td>
                  <td class="table__item center">{{ formatMoney(item.monto_total - item.ajuste) }} USD</td>
                  <td class="table__item center">{{ formatDate(item.fecha_emision) }}</td>
                  <td class="table__item center">{{ formatDate(item.fecha_vencimiento) }}</td>
                  <td class="table__item center">
                    <v-chip :color="statusColor(item.estatus)" small dark style="text-transform: capitalize;">{{ status[item.estatus] }}</v-chip>
                  </td>
                  <td class="table__item center">
                    <v-btn v-if="item.estatus === 'subida'" small color="black" dense class="white--text" style="text-transform: none; font-family: 'montserrat-semibold';" rounded @click="facturaSeleccionada = item, dialogValidateInvoice = true">
                      Validar
                    </v-btn>
                    <v-btn v-else color="black" small class="white--text" style="text-transform: none; font-family: 'montserrat-semibold';" dense rounded @click="facturaSeleccionada = item, dialogAprobarInvoice = true">
                      Aprobar
                    </v-btn>
                    <td class="table__item center">
                    <v-btn color="black" icon @click="abrirDetalle(item)">
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                    </td>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel class="mb-4" style="border-radius: 15px;">
        <v-expansion-panel-header class="py-8" style="font-family: 'montserrat-semibold'; font-size: 16px;">
          Facturas por pagar ({{ invoicesPorPagar?.length || 0 }})
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-col cols="12" class="d-flex justify-end mb-4">
            <v-btn
              color="black"
              class="white--text"
              rounded
              elevation="4"
              style="text-transform: none; font-family: 'montserrat-semibold';"
              :disabled="facturasAPagarSeleccionadas.length === 0"
              @click="dialogRegistrarPago = true"
            >
              Pagar facturas
            </v-btn>
          </v-col>
          <v-data-table
            :items="invoicesPorPagar"
            hide-default-header
            style="background-color: white !important"
            >
            <template v-slot:header>
              <thead style="background-color: #f9fafd;">
                <tr>
                  <th class="header__title left"></th>
                  <th class="header__title center">Cedente</th>
                  <th class="header__title center">Deudor</th>
                  <th class="header__title center">Id</th>
                  <th class="header__title center">Reference</th>
                  <th class="header__title center">Monto</th>
                  <th class="header__title center">Fecha de emisión</th>
                  <th class="header__title center">Fecha de vencimiento</th>
                  <th class="header__title center">Status</th>
                  <th class="header__title right">Acciones</th>
                </tr>
              </thead>
            </template>
            <template v-slot:body="{ items }">
              <tbody style="background: #f9fafd;">
                <tr v-for="item in items" :key="item.id">
                  <td class="table__item">
                    <v-checkbox
                      color="black"
                      v-model="facturasAPagarSeleccionadas"
                      :value="item"
                      :disabled="(clienteSeleccionado && item.cedente_enterprise_id !== clienteSeleccionado)"
                    ></v-checkbox>
                  </td>
                  <td class="table__item center">{{ item.cedente_name }}</td>
                  <td class="table__item center">{{ item.deudor_name }}</td>
                  <td class="table__item center">{{ item.external_invoice_id }}</td>
                  <td class="table__item center">{{ item.reference }}</td>
                  <td class="table__item center">{{ formatMoney(item.monto_total - item.ajuste) }} USD</td>
                  <td class="table__item center">
                    <v-chip :color="statusColor(item.estatus)" small dark style="text-transform: capitalize;">{{ status[item.estatus] }}</v-chip>
                  </td>
                  <td class="table__item center">
                    <v-btn color="black" icon @click="abrirDetalle(item)">
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel class="mb-4" style="border-radius: 15px;">
        <v-expansion-panel-header class="py-8" style="font-family: 'montserrat-semibold'; font-size: 16px;">
          Facturas por cobrar ({{ invoicesPorCobrar?.length || 0 }})
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-col cols="12" class="d-flex justify-end mb-4">
            <v-btn
              color="black"
              class="white--text"
              rounded
              elevation="4"
              style="text-transform: none; font-family: 'montserrat-semibold';"
              :disabled="facturasSeleccionadasCobro.length === 0"
              @click="dialogRegistrarCobro = true, inicializarFacturasCobro()"
            >
              Cobrar facturas
            </v-btn>
          </v-col>
          <v-data-table
            :items="invoicesPorCobrar"
            hide-default-header
            style="background-color: white !important"
            >
            <template v-slot:header>
              <thead style="background-color: #f9fafd;">
                <tr>
                  <th class="header__title left"></th>
                  <th class="header__title center">Cedente</th>
                  <th class="header__title center">Deudor</th>
                  <th class="header__title center">Id</th>
                  <th class="header__title center">Reference</th>
                  <th class="header__title center">Monto</th>
                  <th class="header__title center">Fecha de emisión</th>
                  <th class="header__title center">Fecha de vencimiento</th>
                  <th class="header__title center">Status</th>
                  <th class="header__title right">Acciones</th>
                </tr>
              </thead>
            </template>
            <template v-slot:body="{ items }">
              <tbody style="background: #f9fafd;">
                <tr v-for="item in items" :key="item.id">
                  <td class="table__item">
                    <v-checkbox
                      color="black"
                      v-model="facturasSeleccionadasCobro"
                      :value="item"
                      :disabled="(clienteSeleccionadoCobro && item.deudor_enterprise_id !== clienteSeleccionadoCobro)"
                    ></v-checkbox>
                  </td>
                  <td class="table__item center">{{ item.cedente_name }}</td>
                  <td class="table__item center">{{ item.deudor_name }}</td>
                  <td class="table__item center">{{ item.external_invoice_id }}</td>
                  <td class="table__item center">{{ item.reference }}</td>
                  <td class="table__item center">${{ formatMoney(item.monto_total - item.ajuste) }} USD</td>
                  <td class="table__item center">{{ formatDate(item.fecha_emision) }}</td>
                  <td class="table__item center">{{ formatDate(item.fecha_vencimiento) }}</td>
                  <td class="table__item center">
                    <v-chip :color="statusColor(item.estatus)" small dark style="text-transform: capitalize;">{{ status[item.estatus] }}</v-chip>
                  </td>
                  <td class="table__item center">
                    <v-btn color="black" icon @click="abrirDetalle(item)">
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel class="mb-4" style="border-radius: 15px;">
        <v-expansion-panel-header class="py-8" style="font-family: 'montserrat-semibold'; font-size: 16px;">
          Facturas liquidadas ({{ invoicesLiquidadas?.length || 0 }})
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-data-table
            :items="invoicesLiquidadas"
            hide-default-header
            style="background-color: white !important"
            >
            <template v-slot:header>
              <thead style="background-color: #f9fafd;">
                <tr>
                  <th class="header__title left">Cedente</th>
                  <th class="header__title center">Deudor</th>
                  <th class="header__title center">Id</th>
                  <th class="header__title center">Reference</th>
                  <th class="header__title center">Monto</th>
                  <th class="header__title center">Status</th>
                  <th class="header__title center">Profit</th>
                  <th class="header__title center">Porcentaje de profit</th>
                  <th class="header__title right">Acciones</th>
                </tr>
              </thead>
            </template>
            <template v-slot:body="{ items }">
              <tbody style="background: #f9fafd;">
                <tr v-for="item in items" :key="item.id">
                  <td class="table__item center">{{ item.cedente_name }}</td>
                  <td class="table__item center">{{ item.deudor_name }}</td>
                  <td class="table__item center">{{ item.external_invoice_id }}</td>
                  <td class="table__item center">{{ item.reference }}</td>
                  <td class="table__item center">{{ formatMoney(item.monto_total - item.ajuste) }} USD</td>
                  <td class="table__item center">
                    <v-chip :color="statusColor(item.estatus)" small dark style="text-transform: capitalize;">{{ status[item.estatus] }}</v-chip>
                  </td>
                  <td class="table__item center">$ {{ formatMoney(item.profit) }} USD</td>
                  <td class="table__item center">{{ item.profit > 0 ? ((item.profit / (item.monto_total - item.ajuste || 1)) * 100).toFixed(2) || 0 : 0 }}%</td>
                  <td class="table__item center">
                    <v-btn color="black" icon @click="abrirDetalle(item)">
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-dialog v-model="dialogCreateInvoice" max-width="650px">
      <v-card style="border-radius: 20px; padding: 24px;">
        <v-form ref="formNew" lazy-validation v-on:submit.prevent>
          <!-- Título -->
          <div style="font-family: 'montserrat-bold'; font-size: 22px; text-align: center;">
            Agregar Factura
          </div>

          <v-divider class="my-4" />

          <!-- Información básica -->
          <v-row dense>
            <v-col cols="6">
              <v-text-field
                v-model="factura.external_invoice_id"
                label="PO del Deudor"
                outlined
                style="border-radius: 10px;"
                dense
                class="mb-2"
                hide-details
                :rules="[rules.required]"
                required
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="factura.reference"
                label="Referencia interna (opcional)"
                style="border-radius: 10px;"
                outlined
                class="mb-2"
                hide-details
                dense
              />
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="6">
              <v-select
                v-model="factura.cedenteId"
                :items="cedentes"
                item-text="empresa"
                item-value="enterpriseId"
                label="Cedente"
                outlined
                :rules="[rules.required]"
                dense
                hide-details
                style="border-radius: 10px;"
                @change="cargarDeudores(factura.cedenteId)"
                required
              />
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="factura.deudor"
                :items="deudores"
                return-object
                item-text="empresa"
                item-value="enterpriseId"
                label="Deudor"
                outlined
                dense
                :rules="[rules.required]"
                hide-details
                style="border-radius: 10px;"
                required
              />
            </v-col>
          </v-row>

          <v-divider class="my-4" />

          <v-row dense>
            <v-col cols="6">
              <v-menu
                ref="menuEmision"
                v-model="menuEmision"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="factura.fechaEmision"
                    label="Fecha de Emisión"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :rules="[rules.required]"
                    style="border-radius: 10px;"
                    class="mb-2"
                    outlined
                    hide-details
                    dense
                  />
                </template>
                <v-date-picker v-model="factura.fechaEmision" @input="menuEmision = false" />
              </v-menu>
            </v-col>

            <v-col cols="6">
              <v-menu
                ref="menuVencimiento"
                v-model="menuVencimiento"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="factura.fechaVencimiento"
                    label="Fecha de Vencimiento"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    style="border-radius: 10px;"
                    outlined
                    :rules="[rules.required]"
                    hide-details
                    class="mb-2"
                    dense
                  />
                </template>
                <v-date-picker v-model="factura.fechaVencimiento" @input="menuVencimiento = false" />
              </v-menu>
            </v-col>
          </v-row>

          <!-- Monto y Fechas -->
          <v-row dense style="align-items: center;">
            <v-col cols="6">
              <v-text-field
                v-model.number="factura.monto"
                label="Monto total (USD)"
                type="number"
                outlined
                :rules="[rules.required]"
                dense
                hide-details
                style="border-radius: 10px;"
                required
              />
            </v-col>
            <v-col cols="6">
              <v-card
                flat
                class="d-flex align-center justify-center flex-column py-2"
                style="background-color: #f6f6f6; border-radius: 12px; height: 100%; "
              >
                <div class="mb-1" style="font-family: 'montserrat-bold'; font-size: 14px; color: #333;">
                  Monto total (USD)
                </div>
                <div style="font-family: 'montserrat-bold'; font-size: 20px; color: #333;">
                  ${{ formatMoney(factura.monto) }} USD
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-divider class="my-4" />

          <!-- Documentos adjuntos -->
          <div style="font-family: 'montserrat-semibold'; font-size: 14px;" class="mb-2">Documentos adjuntos</div>

          <v-row dense>
            <v-col
              v-for="(archivo, index) in factura.archivos"
              :key="index"
              cols="12"
              sm="6"
              md="4"
            >
              <v-card class="pa-3 d-flex align-center justify-space-between" outlined>
                <div class="d-flex flex-column">
                  <span style="font-weight: 600;">{{ archivo.name }}</span>
                  <span class="text--secondary text-caption">{{ (archivo.size / 1024).toFixed(1) }} KB</span>
                </div>
                <v-btn icon @click="eliminarArchivo(index)">
                  <v-icon color="red">mdi-close</v-icon>
                </v-btn>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-card
                class="pa-3 d-flex align-center justify-center"
                outlined
                style="cursor: pointer; border: 2px dashed black;"
                @click="$refs.uploader.click()"
              >
                <v-icon size="32" color="black">mdi-plus</v-icon>
                <span class="ml-2 font-weight-medium">Agregar documento</span>
                <input
                  type="file"
                  accept=".pdf,.xml"
                  style="display: none"
                  ref="uploader"
                  @change="agregarArchivoManual"
                />
              </v-card>
            </v-col>
          </v-row>

          <v-divider class="my-4" />

          <!-- Acciones -->
          <v-card-actions>
            <v-btn 
              block
              large
              color="black"
              class="white--text mt-2"
              style="border-radius: 10px; text-transform: none; font-weight: 600;" 
              @click="createInvoice()"
            >
              Guardar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogValidateInvoice" v-if="dialogValidateInvoice" max-width="500px">
      <v-card style="border-radius: 20px; padding: 24px;">
        
        <!-- Encabezado -->
        <div style="font-family: 'montserrat-bold'; font-size: 22px;">Factura #{{ facturaSeleccionada.id }}</div>
        <div class="mb-2" style="font-family: 'montserrat-semibold'; font-size: 16px; color: #333;">{{ facturaSeleccionada.cliente }}</div>

        <!-- Advertencia -->
        <div class="mb-2" style="background-color: #FFF8E4; display: flex; align-items: center; border-radius: 12px; padding: 16px;">
          <div class="mr-4" style="border-right: #FCCA3D solid 4px; height: 100px"></div>
          <div style="display: flex; flex-direction: column;">
            <div style="font-family: 'montserrat-bold'; font-size: 16px; color: #2E404E; margin-bottom: 8px;">
              {{ 'Valida que la información y los documentos sean correctos antes de proceder.' }}
            </div>
          </div>
        </div>

        <v-divider class="my-4" />

        <!-- Monto -->
        <div class="mb-3">
          <div style="font-family: 'montserrat-medium'; font-size: 14px;">Monto de la factura</div>
          <div style="font-size: 24px; font-weight: bold;">${{ formatMoney(facturaSeleccionada.monto_total) }} USD</div>
        </div>

        <!-- Fechas -->
        <v-row dense>
          <v-col cols="6">
            <div style="font-size: 12px; color: #888;">EMISIÓN</div>
            <div>{{ formatDate(facturaSeleccionada.fecha_emision) }}</div>
          </v-col>
          <v-col cols="6">
            <div style="font-size: 12px; color: #888;">VENCIMIENTO</div>
            <div>{{ formatDate(facturaSeleccionada.fecha_vencimiento) }}</div>
          </v-col>
        </v-row>

        <!-- Cedente y Deudor -->
        <v-row dense class="mt-2">
          <v-col cols="6">
            <div style="font-size: 12px; color: #888;">CEDENTE</div>
            <div style="font-size: 14px;">{{ facturaSeleccionada.cedente_name }}</div>
          </v-col>
          <v-col cols="6">
            <div style="font-size: 12px; color: #888;">DEUDOR</div>
            <div style="font-size: 14px;">{{ facturaSeleccionada.deudor_name }}</div>
          </v-col>
        </v-row>

        <v-divider class="my-4" />

        <!-- Documentos -->
        <div class="mb-2" style="font-family: 'montserrat-semibold'; font-size: 15px;">Documentos adjuntos</div>
        <v-row dense>
          <v-col
            v-for="(doc, index) in facturaSeleccionada.documentos || []"
            :key="index"
            cols="12"
            sm="6"
          >
            <v-card class="pa-3 d-flex align-center justify-space-between" outlined>
              <div class="d-flex flex-column">
                <span style="font-weight: 600;">{{ doc.file_name }}</span>
                <span class="text--secondary text-caption">
                  {{ doc.size ? (doc.size / 1024).toFixed(1) + ' KB' : 'Documento subido' }}
                </span>
              </div>
              <v-btn icon @click="abrirDocumento(doc)">
                <v-icon color="primary">mdi-eye</v-icon>
              </v-btn>
            </v-card>
          </v-col>

          <v-list-item v-if="!facturaSeleccionada.documentos || !facturaSeleccionada.documentos.length">
            <v-list-item-content class="grey--text">No hay documentos adjuntos</v-list-item-content>
          </v-list-item>
        </v-row>

        <v-divider class="my-4" />

        <!-- Acción -->
        <v-btn
          block
          large
          color="black"
          class="white--text mt-2"
          style="border-radius: 10px; text-transform: none; font-weight: 600;"
          @click="validateInvoice(facturaSeleccionada.id)"
        >
          Validar factura
        </v-btn>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAprobarInvoice" v-if="dialogAprobarInvoice" max-width="500px">
      <v-card style="border-radius: 20px; padding: 24px;">
        <!-- Encabezado -->
        <div style="font-family: 'montserrat-bold'; font-size: 22px;">Factura #{{ facturaSeleccionada.id }}</div>
        <div class="mb-2" style="font-family: 'montserrat-semibold'; font-size: 16px; color: #333;">{{ facturaSeleccionada.cliente }}</div>

        <!-- Advertencia -->
        <div class="mb-2" style="background-color: #FFF8E4; display: flex; align-items: center; border-radius: 12px; padding: 16px;">
          <div class="mr-4" style="border-right: #FCCA3D solid 4px; height: 100px"></div>
          <div style="display: flex; flex-direction: column;">
            <div style="font-family: 'montserrat-bold'; font-size: 16px; color: #2E404E; margin-bottom: 8px;">
              {{ 'Esta factura aún no ha sido aprobada. Debes examinarla detenidamente antes de tomar cualquier acción.' }}
            </div>
          </div>
        </div>

        <v-divider class="my-4" />
        <!-- Monto -->
        <div class="mb-3">
          <div style="font-family: 'montserrat-medium'; font-size: 14px;">Monto de la factura</div>
          <div style="font-size: 24px; font-weight: bold;">${{ formatMoney(facturaSeleccionada.monto_total) }} USD</div>
        </div>

        <!-- Fechas -->
        <v-row dense>
          <v-col cols="6">
            <div style="font-size: 12px; color: #888;">FECHA DE CARGA</div>
            <div>{{ formatDate(facturaSeleccionada.created_at) }}</div>
          </v-col>
          <v-col cols="6">
            <div style="font-size: 12px; color: #888;">VENCIMIENTO</div>
            <div>{{ formatDate(facturaSeleccionada.fecha_vencimiento) }}</div>
          </v-col>
        </v-row>

        <!-- Cliente -->
        <v-row dense>
          <v-col cols="6">
            <div class="mt-3" style="font-size: 12px; color: #888;">CEDENTE</div>
            <div style="font-size: 14px;">{{ facturaSeleccionada.cedente_name }}</div>
          </v-col>
          <v-col cols="6">
            <div class="mt-3" style="font-size: 12px; color: #888;">DEUDOR</div>
            <div style="font-size: 14px;">{{ facturaSeleccionada.deudor_name }}</div>
          </v-col>
        </v-row>

        <v-divider class="my-4" />
        <!-- Documentos -->
        <div class="mb-2" style="font-family: 'montserrat-semibold'; font-size: 15px;">Documentos adjuntos</div>
        <v-row dense>
          <v-col
            v-for="(doc, index) in facturaSeleccionada.documentos || []"
            :key="index"
            cols="12"
            sm="6"
          >
            <v-card class="pa-3 d-flex align-center justify-space-between" outlined>
              <div class="d-flex flex-column">
                <span style="font-weight: 600;">{{ doc.file_name }}</span>
                <span class="text--secondary text-caption">
                  {{ doc.size ? (doc.size / 1024).toFixed(1) + ' KB' : 'Documento subido' }}
                </span>
              </div>
              <v-btn icon @click="abrirDocumento(doc)">
                <v-icon color="primary">mdi-eye</v-icon>
              </v-btn>
            </v-card>
          </v-col>

          <v-list-item v-if="!facturaSeleccionada.documentos || !facturaSeleccionada.documentos.length">
            <v-list-item-content class="grey--text">No hay documentos adjuntos</v-list-item-content>
          </v-list-item>
        </v-row>

        <v-divider class="my-4" />

        <!-- Términos -->
        <div style="display: flex; justify-content: center;">
          <v-btn text small color="primary" @click="">
            Ver términos y condiciones
          </v-btn>
        </div>

        <v-btn
          block
          large
          color="black"
          class="white--text mt-4"
          style="border-radius: 10px; text-transform: none; font-weight: 600;"
          @click="approveInvoice(facturaSeleccionada.id)"
        >
          Aprobar factura
        </v-btn>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogRegistrarPago" v-if="dialogRegistrarPago" persistent max-width="1200px">
      <v-card style="border-radius: 20px; padding: 24px;">
        <!-- Encabezado -->
        <div style="font-family: 'montserrat-bold'; font-size: 22px;">Registrar transferencia a {{ facturasAPagarSeleccionadas[0].cedente_name }} </div>
        <v-divider class="my-2" />
        <!-- Advertencia -->
        <div class="my-4" style="background-color: #FFF8E4; display: flex; align-items: center; border-radius: 12px; padding: 16px;">
          <div class="mr-4" style="border-right: #FCCA3D solid 4px; height: 60px"></div>
          <div>
            <div style="font-family: 'montserrat-bold'; font-size: 16px; color: #2E404E;">
              Ingresa el monto total de la transferencia y después el desglose de aplicación en las facturas seleccionadas.
            </div>
          </div>
        </div>
        <!-- Monto -->
        <div style="display: flex; justify-content: space-between; ">
          <div class="mb-3">
            <div style="font-family: 'montserrat-medium'; font-size: 14px;">Monto total de la transferencia</div>
            <div style="font-size: 24px; font-weight: bold;">${{ formatMoney(adelanto?.monto) || 0 }} USD</div>
          </div>
          <!-- Monto adelantado -->
          <div style="width: 500px; display: flex; flex-direction: row;">
            <v-text-field
              v-model="adelanto.payment_date"
              label="Fecha del pago"
              type="date"
              outlined
              hide-details
              rounded
              class="mr-4"
            />
            <v-text-field
              v-model.number="adelanto.monto"
              label="Monto a pagar (USD)"
              type="number"
              rounded
              hide-details
              outlined
              class="mb-4"
            />
          </div>
        </div>
        
        <v-divider class="my-4" />
        <div class="mb-2" style="font-family: 'montserrat-bold'; font-size: 16px; color: #333;">
          {{ 'Detalle de las facturas que vas a pagar, tienes que colocar el desglose de los montos:' }}
        </div>
        <v-data-table
          :items="facturasAPagarSeleccionadas"
          hide-default-header
          style="background-color: white !important"
          >
          <template v-slot:header>
            <thead style="background-color: #f9fafd;">
              <tr>
                <th class="header__title left">Cedente</th>
                <th class="header__title center">Deudor</th>
                <th class="header__title center">Id</th>
                <th class="header__title center">Reference</th>
                <th class="header__title center">Monto total de la factura</th>
                <th class="header__title center">Monto pendiente</th>
                <th class="header__title center">Fecha de emisión</th>
                <th class="header__title center">Porcentaje de pago</th>
                <th class="header__title right">Desglose de aplicación</th>
              </tr>
            </thead>
          </template>
          <template v-slot:body="{ items }">
            <tbody style="background: #f9fafd;">
              <tr v-for="item in items" :key="item.id">
                <td class="table__item center">{{ item.cedente_name }}</td>
                <td class="table__item center">{{ item.deudor_name }}</td>
                <td class="table__item center">{{ item.external_invoice_id }}</td>
                <td class="table__item center">{{ item.reference }}</td>
                <td class="table__item center">$ {{ formatMoney(item.monto_total - item.ajuste) }} USD</td>
                <td class="table__item center">$ {{ formatMoney(item.monto_cobrado - item.monto_adelantado - item.profit) }} USD</td>
                <td class="table__item center">
                  <v-chip :color="statusColor(item.estatus)" small dark style="text-transform: capitalize;">{{ status[item.estatus] }}</v-chip>
                </td>
                <td class="table__item center">{{ item.estatus == 'aprobada' ? (item.montoPagado > 0 ? (item.montoPagado / (item.monto_total - item.ajuste) * 100).toFixed(2) || 0 : 0) : item.montoPagado > 0 ? (item.montoPagado / (item.monto_cobrado - item.monto_adelantado - item.profit || 1) * 100).toFixed(2) || 0 : 0 }}%</td>
                <td class="table__item center">
                  <v-text-field
                    v-model.number="item.montoPagado"
                    type="number"
                    hide-details
                    dense
                    style="max-width: 120px;"
                    min="0"
                  />
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <div class="mt-2" :style="{ color: adelanto.monto === sumaAplicaciones ? 'green' : 'red', fontFamily: 'montserrat-bold', fontSize: '16px' }">
          Total asignado: ${{ formatMoney(sumaAplicaciones) }} / Pendiente de asignar: ${{ formatMoney(adelanto.monto - sumaAplicaciones) }}
        </div>
        <v-divider class="my-4" />
        <div class="mb-2" style="font-family: 'montserrat-semibold'; font-size: 14px;">Comprobante de pago</div>
        <v-file-input
          v-model="adelanto.comprobante"
          label="Selecciona archivo"
          accept=".pdf,.jpg,.png"
          show-size
          rounded
          dense
          outlined
        />
        <v-divider class="my-4" />

        <!-- Acción -->
        <div style="display: flex; justify-content: space-between;">
          <v-btn
            large
            color="black"
            :disabled="false"
            class="white--text mt-2"
            style="border-radius: 10px; text-transform: none; font-weight: 600;"
            @click="dialogRegistrarPago = false, facturasAPagarSeleccionadas = [], adelanto = { monto: null, comprobante: null, payment_date: null }"
            >
            Cerrar
          </v-btn>
          <v-btn
            large
            color="black"
            :disabled="!adelanto.monto || adelanto.monto <= 0 || parseFloat(adelanto.monto).toFixed(2) !== parseFloat(sumaAplicaciones).toFixed(2)"
            class="white--text mt-2"
            style="border-radius: 10px; text-transform: none; font-weight: 600;"
            @click="registrarPago()"
            >
            Registrar pago
          </v-btn>
        </div>
        
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogRegistrarCobro" v-if="dialogRegistrarCobro" persistent max-width="1200px">
      <v-card style="border-radius: 20px; padding: 24px;">
        <!-- Encabezado -->
        <div style="font-family: 'montserrat-bold'; font-size: 22px;">Registrar cobro a {{ facturasSeleccionadasCobro[0].deudor_name }} </div>
        <v-divider class="my-2" />
        <!-- Advertencia -->
        <div class="my-4" style="background-color: #FFF8E4; display: flex; align-items: center; border-radius: 12px; padding: 16px;">
          <div class="mr-4" style="border-right: #FCCA3D solid 4px; height: 60px"></div>
          <div>
            <div style="font-family: 'montserrat-bold'; font-size: 16px; color: #2E404E;">
              Ingresa el monto total de la transferencia y después el desglose de aplicación en las facturas seleccionadas.
            </div>
          </div>
        </div>
        <!-- Monto -->
        <div style="display: flex; justify-content: space-between; ">
          <div class="mb-3">
            <div style="font-family: 'montserrat-medium'; font-size: 14px;">Monto total de la transferencia</div>
            <div style="font-size: 24px; font-weight: bold;">${{ cobro?.monto >= 0 ? formatMoney(cobro?.monto) : 0 }} USD</div>
          </div>
          <!-- Monto adelantado -->
          <div style="width: 500px; display: flex; flex-direction: row;">
            <v-text-field
              v-model="cobro.payment_date"
              label="Fecha del cobro"
              @change="inicializarFacturasCobro()"
              type="date"
              outlined
              hide-details
              rounded
              class="mr-4"
            />
            <v-text-field
              v-model.number="cobro.monto"
              label="Monto a cobrar (USD)"
              type="number"
              rounded
              hide-details
              outlined
              class="mb-4"
            />
          </div>
        </div>
        
        <v-divider class="my-4" />
        <div class="mb-2" style="font-family: 'montserrat-bold'; font-size: 16px; color: #333;">
          {{ 'Detalle de las facturas que vas a cobrar, tienes que colocar el desglose de los montos:' }}
        </div>
        <v-data-table
          :items="facturasSeleccionadasCobro"
          hide-default-header
          style="background-color: white !important"
          >
          <template v-slot:header>
            <thead style="background-color: #f9fafd;">
              <tr>
                <th class="header__title left">Cedente</th>
                <th class="header__title center">Deudor</th>
                <th class="header__title center">Id</th>
                <th class="header__title center">Reference</th>
                <th class="header__title center">Monto adelantado</th>
                <th class="header__title center">Interes generado</th>
                <th class="header__title center">Interes moratorio</th>
                <th class="header__title center">Dias moratorios</th>
                <th class="header__title center">Monto expuesto</th>
                <th class="header__title center">Monto total de la factura</th>
                <th class="header__title center">Fecha de vencimiento</th>
                <th class="header__title right">Desglose de aplicación</th>
              </tr>
            </thead>
          </template>
          <template v-slot:body="{ items }">
            <tbody style="background: #f9fafd;">
              <tr v-for="item in items" :key="item.id">
                <td class="table__item center">{{ item.cedente_name }}</td>
                <td class="table__item center">{{ item.deudor_name }}</td>
                <td class="table__item center">{{ item.external_invoice_id }}</td>
                <td class="table__item center">{{ item.reference }}</td>
                <td class="table__item center">$ {{ formatMoney(item.monto_adelantado) }} USD</td>
                <td class="table__item center">
                  <v-text-field 
                    v-model.number="item.interes_generado" 
                    type="number" 
                    hide-details 
                    dense 
                    style="max-width: 120px;" 
                    @input="recalcularExpuesto(item)"
                  />
                </td>
                <td class="table__item center"><v-text-field
                  v-model.number="item.interes_moratorio"
                  type="number"
                  hide-details
                  dense
                  style="max-width: 120px;"
                  @input="item.moratorio_editado = true; recalcularExpuesto(item)"
                  />
                </td>
                <td class="table__item center" :style="{ color: item.dias_moratorios > 0 ? 'red' : 'green' }">{{ item.dias_moratorios }}</td>
                <td class="table__item center">$ {{ formatMoney(item.monto_expuesto) }} USD</td>
                <td class="table__item center">$ {{ formatMoney(item.monto_total - item.ajuste) }} USD</td>
                <td class="table__item center">{{ formatDate(item.fecha_vencimiento) }}</td>
                <td class="table__item center">
                  <v-text-field
                    v-model.number="item.monto_cobrado"
                    type="number"
                    hide-details
                    dense
                    style="max-width: 120px;"
                    min="0"
                  />
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <div class="mt-2" :style="{ color: cobro.monto === sumaAplicacionesCobro ? 'green' : 'red', fontFamily: 'montserrat-bold', fontSize: '16px' }">
          Total asignado: ${{ formatMoney(sumaAplicacionesCobro) }} / Pendiente de asignar: ${{ cobro.monto - sumaAplicacionesCobro >= 0 ? formatMoney(cobro.monto - sumaAplicacionesCobro) : 0 }}
        </div>
        <v-divider class="my-4" />
        <div class="mb-2" style="font-family: 'montserrat-semibold'; font-size: 14px;">Comprobante de cobro</div>
        <v-file-input
          v-model="cobro.comprobante"
          label="Selecciona archivo"
          accept=".pdf,.jpg,.png"
          show-size
          rounded
          dense
          outlined
        />
        <v-divider class="my-4" />

        <!-- Acción -->
        <div style="display: flex; justify-content: space-between;">
          <v-btn
            large
            color="black"
            :disabled="false"
            class="white--text mt-2"
            style="border-radius: 10px; text-transform: none; font-weight: 600;"
            @click="dialogRegistrarCobro = false, facturasSeleccionadasCobro = [], cobro = { monto: null, comprobante: null, payment_date: null,  }"
            >
            Cerrar
          </v-btn>
          <v-btn
            large
            color="black"
            :disabled="!cobro.monto || cobro.monto <= 0 || parseFloat(cobro.monto).toFixed(2) !== sumaAplicacionesCobro.toFixed(2)"
            class="white--text mt-2"
            style="border-radius: 10px; text-transform: none; font-weight: 600;"
            @click="registrarCobro()"
            >
            Registrar cobro
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      facturasSeleccionadas: [],
      facturasAPagarSeleccionadas: [],
      facturasSeleccionadasCobro: [],
      dialogCreateInvoice: false,
      dialogAprobarInvoice: false,
      dialogRegistrarCobro: false,
      dialogValidateInvoice: false,
      dialogRegistrarPago: false,
      dialogCobrarFactura: false,
      dialogLiquidarFactura: false,
      liquidacion: {
        monto: null,
        referencia: '',
        comprobante: null,
        nota: ''
      },
      cobro: {
        comprobante: null,
        nota: '',
        monto: null,
        referencia: '',
        origen: '',
        destino: ''
      },
      adelanto: {
        comprobante: null,
        nota: '',
        monto: null,
        referencia: '',
        origen: '',
        destino: ''
      },
      cuentaDestino: {
        banco: 'Banco Nacional',
        numero: '1234567890',
        clabe: '012345678901234567'
      },
      facturasSeleccionadas: [],
      facturasSeleccionadasCobro: [],
      invoicesPorValidar: [],
      invoicesPorPagar: [],
      invoicesPorCobrar: [],
      invoicesLiquidadas: [],
      cedentes: [],
      deudores: [],
      facturaSeleccionada: null,
      selectedStatus: 'todos',
      statusList: [
        { label: 'Todas', value: 'todos' },
        { label: 'Por validar', value: 'subida' },
        { label: 'En aprobación', value: 'validada' },
        { label: 'Por adelantar', value: 'aprobada' },
        { label: 'Por cobrar', value: 'adelantada' },
        { label: 'Por liquidar', value: 'cobrada' },
        { label: 'Liquidadas', value: 'liquidada' },
      ],
      isLoading: false,
      factura: {
        external_invoice_id: "",
        reference: "",
        deudor: null,
        monto: null,
        fechaEmision: null,
        fechaVencimiento: null,
        archivos: []
      },
      menuEmision: false,
      menuVencimiento: false,
      rules: {
        required: (v) => !!v || "El campo es obligatorio",
      },
      status: {
        subida: 'Por validar',
        validada: 'Por aprobar',
        aprobada: 'Por adelantar',
        adelantada: 'Por cobrar',
        cobrada: 'Por liquidar',
        liquidada: 'Liquidadas',
      }
    };
  },
  computed: {
    montoSugerido() {
      const pagoDeudor = this.facturaSeleccionada.monto_cobrado || 0;
      const adelantos = (this.facturaSeleccionada.monto_adelantado) || 0;
      const interesCrudo = (this.facturaSeleccionada.monto_total || 0) * (this.facturaSeleccionada.tasa_interes / 100);
      const interes = Math.round(interesCrudo * 100) / 100;
      const diasMoratorios = Math.max(0, this.facturaSeleccionada.dias_moratorios);
      const interesMoratorioCrudo = (this.facturaSeleccionada.monto_total || 0) * (diasMoratorios / 30 * (this.facturaSeleccionada.tasa_interes / 100));
      const interesMoratorio = Math.round(interesMoratorioCrudo * 100) / 100; 

      return Math.max(pagoDeudor - adelantos - interes - interesMoratorio);
    },
    clienteSeleccionadoCobro() {
      return this.facturasSeleccionadasCobro.length > 0
        ? this.facturasSeleccionadasCobro[0].deudor_enterprise_id
        : null;
    },
    sumaAplicacionesCobro() {
      return this.facturasSeleccionadasCobro.reduce((acc, d) => acc + Number(d.monto_cobrado || 0), 0);
    },
    clienteSeleccionado() {
      return this.facturasAPagarSeleccionadas.length > 0
        ? this.facturasAPagarSeleccionadas[0].cedente_enterprise_id
        : null;
    },
    sumaAplicaciones() {
      return this.facturasAPagarSeleccionadas.reduce((acc, d) => acc + Number(d.montoPagado || 0), 0);
    },
  },
  methods: {
    async getInvoices() {
      try {
        this.isLoading = true;

        const response = await DB.get(`${URI}/api/v1/en/factoringInvoices/admin/invoices`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        this.isLoading = false;
        this.invoicesPorValidar = response.data.invoicesPorValidar || [];
        this.invoicesPorPagar = response.data.invoicesPorPagar || [];
        this.invoicesPorCobrar = response.data.invoicesPorCobrar || [];
        this.invoicesLiquidadas = response.data.invoicesLiquidadas || [];
        this.facturaSeleccionada = [];
        this.facturasAPagarSeleccionadas = [];
        this.facturasSeleccionadasCobro = [];
        this.adelanto = { monto: null, origen: '', comprobante: null, payment_date: null };
      } catch (error) {
        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      } finally {
        this.isLoading = false;
      }
    },
    statusColor(status) {
      return {
        subida: 'blue',
        validada: 'blue',
        aprobada: 'green',
        adelantada: 'orange',
        cobrada: 'purple',
        liquidada: 'grey',
      }[status] || 'grey';
    },
    async getCedentes() {
      try {
        this.isLoading = true;

        const response = await DB.get(`${URI}/api/v1/en/contracts/cedentes`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        this.isLoading = false;
        this.cedentes = response.data.cedentes || [];
      } catch (error) {
        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      } finally {
        this.isLoading = false;
      }
    },
    async cargarDeudores(cedenteId) {
      try {
        this.isLoading = true;

        const response = await DB.get(`${URI}/api/v1/en/contracts/debtors/${cedenteId}`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        this.isLoading = false;
        this.deudores = response.data.deudores || [];
      } catch (error) {
        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      } finally {
        this.isLoading = false;
      }
    },
    async createInvoice() {
      const isValid = await this.$refs.formNew.validate();

      if (!isValid) {
        this.mixError('Revisa los campos obligatorios antes de continuar');
        return;
      }

      try {
        this.isLoading = true;

        const formData = new FormData();
        formData.append('external_invoice_id', this.factura.external_invoice_id);
        formData.append('reference', this.factura.reference || '');
        formData.append('contractId', this.factura.deudor.contractId);
        formData.append('monto', this.factura.monto);
        formData.append('moneda', 'USD');
        formData.append('fechaEmision', this.factura.fechaEmision);
        formData.append('fechaVencimiento', this.factura.fechaVencimiento);

        this.factura.archivos.forEach(file => {
          formData.append('archivos', file);
        });

        const response = await DB.post(`${URI}/api/v1/en/factoringInvoices/admin/invoices`, formData, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : '',
            'Content-Type': 'multipart/form-data'
          }
        });

        this.isLoading = false;
        this.mixSuccess(response.data.message || 'Factura creada correctamente');
        this.dialogCreateInvoice = false;
        this.factura = {
          external_invoice_id: "",
          reference: "",
          deudor: null,
          monto: null,
          fechaEmision: null,
          fechaVencimiento: null,
          archivos: []
        };
        this.getInvoices();
      } catch (error) {
        this.isLoading = false;
        this.mixError(error.response?.data?.message, error.response?.status);
      }
    },
    abrirDocumento(doc) {
      window.open(`${doc.file_url}`, '_blank');
    },
    async validateInvoice(invoiceId) {
      try {
        this.isLoading = true;

        const response = await DB.get(`${URI}/api/v1/en/factoringInvoices/validate/${invoiceId}`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        this.isLoading = false;
        this.mixSuccess(response.data.message || 'Factura actualizada correctamente');
        this.dialogValidateInvoice = false;
        this.facturaSeleccionada = null;
        this.getInvoices();
      } catch (error) {
        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      } finally {
        this.isLoading = false;
      }
    },
    async approveInvoice(invoiceId) {
      try {
        this.isLoading = true;

        const response = await DB.get(`${URI}/api/v1/en/factoringInvoices/approve/${invoiceId}`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        this.isLoading = false;
        this.mixSuccess(response.data.message || 'Factura actualizada correctamente');
        this.dialogAprobarInvoice = false;
        this.facturaSeleccionada = null;
        this.getInvoices();
      } catch (error) {
        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      } finally {
        this.isLoading = false;
      }
    },
    async registrarPago() {
      try {
        this.isLoading = true;

        const formData = new FormData();
        formData.append('cedente_enterprise_id', this.facturasAPagarSeleccionadas[0].cedente_enterprise_id);
        formData.append('payment_date', this.adelanto.payment_date);
        formData.append('total_amount', this.adelanto.monto);
        formData.append('origin', this.origin || '');
        formData.append('destination', this.destination || '');
        formData.append('reference', this.reference || '');
        formData.append('note', this.note || '');

        formData.append(
          'applications',
          JSON.stringify(
            this.facturasAPagarSeleccionadas.map(f => ({
              invoice_id: f.id,
              amount_applied: f.montoPagado || 0
            }))
          )
        );

        if (this.adelanto.comprobante) {
          formData.append('document', this.adelanto.comprobante);
        }

        const response = await DB.post(`${URI}/api/v1/en/paymentsCedente/createPaymentToCedente`, formData,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.sToken}`,
              'Content-Type': 'multipart/form-data'
            }
          }
        );

        this.$toast.success('Pago registrado correctamente.');
        this.dialogRegistrarPago = false;
        this.facturasAPagarSeleccionadas = [];
        this.facturasSeleccionadas = [];
        this.getInvoices();
      } catch (error) {
        this.$toast.error('Error al registrar pago.');
      } finally {
        this.isLoading = false;
      }
    },
    async registrarCobro() {
      try {
        this.isLoading = true;

        const formData = new FormData();
        formData.append('payer_enterprise_id', this.facturasSeleccionadasCobro[0].deudor_enterprise_id);
        formData.append('date_collected', this.cobro.payment_date);
        formData.append('total_amount', this.cobro.monto);
        formData.append('origin', this.cobro.origen || '');
        formData.append('destination', this.cobro.destino || '');
        formData.append('reference', this.cobro.referencia || '');
        formData.append('note', this.cobro.nota || '');

        formData.append(
          'applications',
          JSON.stringify(
            this.facturasSeleccionadasCobro.map(f => ({
              invoice_id: f.id,
              monto_cobrado: f.monto_cobrado || 0,
              monto_expuesto: f.monto_expuesto || 0,
              cedente_enterprise_id: f.cedente_enterprise_id,
            }))
          )
        );

        if (this.cobro.comprobante) {
          formData.append('document', this.cobro.comprobante);
        }

        const response = await DB.post(`${URI}/api/v1/en/paymentsDebtor/createCollectionFromDeudor`, formData,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.sToken}`,
              'Content-Type': 'multipart/form-data'
            }
          }
        );

        this.$toast.success('Cobro registrado correctamente.');
        this.dialogRegistrarCobro = false;
        this.facturasSeleccionadasCobro = [];
        this.facturasSeleccionadas = [];
        this.getInvoices();
      } catch (error) {
        this.$toast.error('Error al registrar cobro.');
      } finally {
        this.isLoading = false;
      }
    },
    agregarArchivoManual(event) {
      const archivo = event.target.files[0];
      if (archivo) {
        this.factura.archivos.push(archivo);
      }
      // resetear input para poder volver a subir el mismo archivo si lo desea
      event.target.value = null;
    },
    eliminarArchivo(index) {
      this.factura.archivos.splice(index, 1);
    },
    formatMoney(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM DD, YYYY");
      return formattedDate;
    },
    isVencida(fecha) {
      const hoy = new Date();
      const vencimiento = new Date(fecha);
      return vencimiento < hoy;
    },
    abrirDetalle(factura) {
      this.$router.push({
        name: 'FacturaDeudorDetalle',
        params: { invoiceId: factura.id }
      });
    },
    diasMoratorios(fechaVencimiento, fechaCobro) {
      const vencimiento = new Date(fechaVencimiento);
      const cobro = new Date(fechaCobro);
      const diffTime = cobro - vencimiento;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays > 0 ? diffDays : 0;
    },
    inicializarFacturasCobro() {
      this.facturasSeleccionadasCobro = this.facturasSeleccionadasCobro.map(inv => {
        const dias = this.diasMoratorios(inv.fecha_vencimiento, this.cobro.payment_date)
        const interesGenerado = Math.round(
          (
            Number(inv.monto_total || 0) *
            Number(inv.tasa_interes || 0) / 100
          ) * 100
        ) / 100
        const interesMoratorio = Math.round(
          (
            Number(inv.monto_total || 0) *
            Number(inv.tasa_interes || 0) / 100 *
            dias / 30
          ) * 100
        ) / 100

        return {
          ...inv,
          dias_moratorios: dias,
          interes_generado: interesGenerado,
          interes_moratorio: interesMoratorio,
          monto_expuesto:
            Number(inv.monto_adelantado || 0) +
            interesGenerado +
            interesMoratorio,
          monto_cobrado: 0
        }
      })
    },
    recalcularExpuesto(item) {
      item.monto_expuesto =
        Number(item.monto_adelantado || 0) +
        Number(item.interes_generado || 0) +
        Number(item.interes_moratorio || 0)
    }
  },
  beforeMount() {
    this.getInvoices();
    this.getCedentes();
  },
};
</script>

<style>
  .v-expansion-panel:not(:first-child)::after {
    border-top: none !important;
  }
</style>